import { render, staticRenderFns } from "./CoursesSection.vue?vue&type=template&id=97166590&"
import script from "./CoursesSection.vue?vue&type=script&lang=js&"
export * from "./CoursesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports